import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsuranceIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2276_89",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 40,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2276_89)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20 35.8013C16.3839 34.8182 13.3965 32.6775 11.0379 29.3792C8.67931 26.0808 7.5 22.4132 7.5 18.3763V8.91042L20 4.23083L32.5 8.91042V18.3763C32.5 22.4132 31.3207 26.0808 28.9621 29.3792C26.6035 32.6775 23.6161 34.8182 20 35.8013ZM20 33.6175C22.8114 32.7131 25.1525 30.9978 27.0233 28.4717C28.8944 25.9456 29.9885 23.1217 30.3054 20H20V6.485L9.59417 10.36V18.3763C9.59417 18.6788 9.59875 18.9429 9.60792 19.1688C9.61708 19.3946 9.64597 19.6717 9.69458 20H20V33.6175Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgInsuranceIcon);
export { ForwardRef as ReactComponent };
